(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const initTilt = () => {
    if (reduceMotion || !window.matchMedia('(hover: hover)').matches) return;
    document.querySelectorAll('[data-tilt]').forEach((card) => {
      card.addEventListener('pointermove', (event) => {
        const rect = card.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width;
        const y = (event.clientY - rect.top) / rect.height;
        card.style.setProperty('--ry', `${(x - 0.5) * 22}deg`);
        card.style.setProperty('--rx', `${(0.5 - y) * 18}deg`);
        card.style.setProperty('--mx', `${x * 100}%`);
        card.style.setProperty('--my', `${y * 100}%`);
      });
      card.addEventListener('pointerleave', () => {
        ['--rx', '--ry'].forEach((prop) => card.style.setProperty(prop, '0deg'));
        ['--mx', '--my'].forEach((prop) => card.style.setProperty(prop, '50%'));
      });
    });
  };

  const initReveal = () => {
    const targets = document.querySelectorAll(
      '.section-featured .card, .member__copy, .rule, .signup__panel, .section-head, .story__copy, .story__media, .service'
    );
    if (reduceMotion || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px' }
    );
    targets.forEach((el, i) => {
      el.setAttribute('data-reveal', '');
      el.style.transitionDelay = `${(i % 3) * 90}ms`;
      observer.observe(el);
    });
  };

  const formatMoney = (cents) => {
    const currency = window.Shopify?.currency?.active || 'USD';
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency',
      currency,
    }).format(cents / 100);
  };

  const initProduct = () => {
    const section = document.querySelector('[data-product-section]');
    if (!section) return;
    const jsonEl = section.querySelector('[data-product-json]');
    if (!jsonEl) return;
    const variants = JSON.parse(jsonEl.textContent);
    const idInput = section.querySelector('[data-variant-id]');
    const priceEl = section.querySelector('[data-price]');
    const button = section.querySelector('[data-add-button]');
    const label = section.querySelector('[data-add-label]');
    const strings = {
      add: label?.textContent.trim(),
      soldOut: button?.dataset.soldOut || 'Sold out',
    };

    section.querySelectorAll('.option__input').forEach((input) => {
      input.addEventListener('change', () => {
        const selected = [...section.querySelectorAll('.option__input:checked')].map((el) => el.value);
        const variant = variants.find((v) => v.options.every((opt, i) => opt === selected[i]));
        const valueLabel = section.querySelector(`[data-option-value="${input.dataset.optionIndex}"]`);
        if (valueLabel) valueLabel.textContent = input.value;
        if (!variant) {
          button.disabled = true;
          return;
        }
        idInput.value = variant.id;
        priceEl.textContent = formatMoney(variant.price);
        button.disabled = !variant.available;
        label.textContent = variant.available ? strings.add : strings.soldOut;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      });
    });
  };

  const showToast = () => {
    const toast = document.getElementById('CartToast');
    if (!toast) return;
    toast.hidden = false;
    clearTimeout(showToast.timer);
    showToast.timer = setTimeout(() => (toast.hidden = true), 3200);
  };

  const updateCount = async () => {
    const res = await fetch(`${window.routes.cart_url}.js`);
    const cart = await res.json();
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.classList.remove('is-bumped');
      void el.offsetWidth;
      el.classList.add('is-bumped');
    });
  };

  const initAjaxCart = () => {
    document.querySelectorAll('[data-product-section][data-ajax="true"] form[action*="/cart/add"]').forEach((form) => {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const button = form.querySelector('[data-add-button]');
        button.disabled = true;
        try {
          const res = await fetch(`${window.routes.cart_add_url}.js`, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form),
          });
          if (!res.ok) throw new Error('add failed');
          await updateCount();
          showToast();
        } catch (e) {
          form.submit();
        } finally {
          button.disabled = false;
        }
      });
    });
  };

  const start = () => {
    initTilt();
    initReveal();
    initProduct();
    initAjaxCart();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
